import { formatDateFromTimestamp } from 'apps/journeys/utils/helpers/dates';
import PropTypes from 'prop-types';

const TripsAndMeetingsRowDetails = ({ contact = {} }) => {
  const lastMeetingDate = contact?.trip_interaction?.last_meeting_date;
  const lastInteractionDate = contact?.trip_interaction?.last_interaction_date;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div>Meeting scheduled: {lastMeetingDate ? formatDateFromTimestamp(lastMeetingDate) : 'NA'}</div>
      <div className="giving-date">
        Last recorded interaction: {lastInteractionDate ? formatDateFromTimestamp(lastInteractionDate) : 'NA'}
      </div>
    </div>
  );
};

TripsAndMeetingsRowDetails.propTypes = {
  contact: PropTypes.object,
};

export default TripsAndMeetingsRowDetails;
